module.exports = __webpack_public_path__ + "mf.svg?d7647f6c1ba0431e6e97e6eefd7ec479";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mf.svg
// module id = 1123
// module chunks = 27